import Logo from '../../components/Logo';
import { useState, useEffect } from 'react';
import '../../App.css';
import Button from '@mui/material/Button';
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import api from '../../api'
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeviceInfoDialog from '../../components/DeviceInfoDialog';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import FilterIcon from '@mui/icons-material/FilterList';
import FilterDialog from '../../components/FilterDialog';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingIcon from '@mui/icons-material/Pending';
import LogoutButton from '../../components/LogoutButton';
import DownloadIcon from '@mui/icons-material/Download';


const MatchedList = () => {
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [isLandscape, setIsLandscape] = useState(
    window.screen.orientation
      ? window.screen.orientation.type.includes('landscape')
      : window.innerWidth > window.innerHeight
  );
  const [availableBatches, setAvailableBatches] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState('all');
  const [matchStatus, setMatchStatus] = useState('all');
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [selectedDevEui, setSelectedDevEui] = useState(null);
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [qcStatus, setQcStatus] = useState('all');
  const [qrMatchStatus, setQrMatchStatus] = useState('all');
  const [deviceModel, setDeviceModel] = useState('all');

  useEffect(() => {
    if (token.length > 0) {
      loadServerRows();
    }
  }, [refresh, token]);

  const loadServerRows = async (isLoadMore = false) => {
    try {
      if (!hasMore && isLoadMore) return;
      if (isLoading) return;
      
      setIsLoading(true);
      const currentPage = isLoadMore ? page : 0;
      const batchQuery = selectedBatches === 'all' ? '' : 
        selectedBatches ? `&batchIds=${selectedBatches}` : '';
      const matchStatusQuery = matchStatus !== 'all' ? `&matchStatus=${matchStatus}` : '';
      const qcStatusQuery = qcStatus !== 'all' ? `&qcStatus=${qcStatus}` : '';
      const qrMatchQuery = qrMatchStatus !== 'all' ? `&qrMatchStatus=${qrMatchStatus}` : '';
      const deviceModelQuery = deviceModel !== 'all' ? `&deviceModel=${deviceModel}` : '';
      
      const response = await api.get(
        `/matched_devices?page=${currentPage}&size=${pageSize}&query=${query}${batchQuery}${matchStatusQuery}${qcStatusQuery}${qrMatchQuery}${deviceModelQuery}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + localStorage.getItem("jwt"),
          }
        }
      );

      if (response.data && response.data.rows) {
        if (isLoadMore) {
          const newRows = response.data.rows.filter(newRow => 
            !rows.some(existingRow => existingRow.id === newRow.id)
          );
          setRows(prevRows => [...prevRows, ...newRows]);
        } else {
          setRows(response.data.rows);
        }
        setTotalRows(response.data.count);
        setHasMore(response.data.hasMore);
      }
    } catch (error) {
      window.showToast(error.message, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setPage(0);
    setRows([]);
    loadServerRows(false);
  }, [ selectedBatches, matchStatus, qcStatus, qrMatchStatus]);

  useEffect(() => {
    const handleOrientationChange = () => {
      if (window.screen.orientation) {
        setIsLandscape(window.screen.orientation.type.includes('landscape'));
      } else {
        setIsLandscape(window.innerWidth > window.innerHeight);
      }
    };

    handleOrientationChange();
    if (window.screen.orientation) {
      window.screen.orientation.addEventListener('change', handleOrientationChange);
    }
    window.addEventListener('resize', handleOrientationChange);
    window.addEventListener('orientationchange', handleOrientationChange);

    return () => {
      if (window.screen.orientation) {
        window.screen.orientation.removeEventListener('change', handleOrientationChange);
      }
      window.removeEventListener('resize', handleOrientationChange);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    console.log('Orientation changed:', isLandscape ? 'landscape' : 'portrait');
  }, [isLandscape]);

  useEffect(() => {
    const loadAvailableBatches = async () => {
      try {
        const response = await api.get('/available_batches', {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + localStorage.getItem("jwt"),
          }
        });
        setAvailableBatches(response.data);
      } catch (error) {
        console.error('Error loading batches:', error);
        window.showToast(error.message, 'error');
      }
    };

    loadAvailableBatches();
  }, []);

  useEffect(() => {
    const localToken = localStorage.getItem("jwt");
    if (localToken && localToken.length > 0) {
      setToken(localToken);
    }
  }, []);

  const renderQrCell = (params) => {
    const isNotMatched = !params.row.qr_code_match_date;
    return (
      <div style={{
        backgroundColor: isNotMatched ? '#ef5350' : 'transparent',
        padding: isNotMatched ? '4px 8px' : '0',
        borderRadius: isNotMatched ? '4px' : '0',
        width: '100%',
        color: isNotMatched ? 'white' : 'inherit',
        fontWeight: isNotMatched ? '500' : 'normal'
      }}>
        {isNotMatched ? 'NOT MATCHED' : params.row.qr_code}
      </div>
    );
  };

  const renderQcCell = (params) => {
    let icon, color;

    if (params.row.quality_control === true) {
      icon = <CheckCircleIcon />;
      color = '#66bb6a';
    } else if (params.row.quality_control === false) {
      icon = <CancelIcon />;
      color = '#ef5350';
    } else {
      icon = <PendingIcon />;
      color = '#ffa726';
    }

    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: color
      }}>
        {icon}
      </div>
    );
  };

  const portraitColumns = [
    {
      field: 'qr_code',
      headerName: 'QR',
      flex: 1.2,
      minWidth: 80,
      renderCell: renderQrCell
    },
    {
      field: 'dev_eui',
      headerName: 'DEV',
      flex: 1,
      minWidth: 70,
      valueGetter: (params) => {
        const fullDevEui = params.row.dev_eui || '';
        const model = params.row.device_model_name || '';
        return fullDevEui.slice(-6);
      }
    },
    {
      field: 'quality_control',
      headerName: 'QC',
      flex: 0.7,
      minWidth: 60,
      renderCell: renderQcCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'qr_code_match_date',
      headerName: 'DATE',
      flex: 1,
      minWidth: 70,
      valueGetter: (params) => {
        if (!params.row.qr_code_match_date) return '...';
        const date = new Date(params.row.qr_code_match_date);
        return date.toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        });
      }
    },
    {
      field: 'actions',
      headerName: '',
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleInfoClick(params.row.dev_eui)}
          size="small"
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      )
    }
  ];

  const landscapeColumns = [
    {
      field: 'qr_code',
      headerName: 'QR',
      flex: 1.2,
      minWidth: 90,
      renderCell: renderQrCell
    },
    {
      field: 'dev_eui',
      headerName: 'DEV',
      flex: 0.8,
      minWidth: 70,
      valueGetter: (params) => {
        const fullDevEui = params.row.dev_eui || '';
        const model = params.row.device_model_name || '';
        return fullDevEui.slice(-6);
      }
    },
    {
      field: 'quality_control',
      headerName: 'QC',
      flex: 0.8,
      minWidth: 60,
      renderCell: renderQcCell,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'qr_code_match_date',
      headerName: 'MATCH',
      flex: 1,
      minWidth: 80,
      valueGetter: (params) => {
        if (!params.row.qr_code_match_date) return '...';
        const date = new Date(params.row.qr_code_match_date);
        return date.toLocaleString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: '2-digit'
        });
      }
    },
    {
      field: 'batch_name',
      headerName: 'BATCH',
      flex: 1.2,
      minWidth: 120,
      valueGetter: (params) => {
        return params.row.batch_name || 'N/A';
      }
    },
    {
      field: 'firmware_version',
      headerName: 'FW',
      flex: 0.8,
      minWidth: 60,
      valueGetter: (params) => {
        return params.row.firmware_version || 'N/A';
      }
    },
    {
      field: 'actions',
      headerName: '',
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          onClick={() => handleInfoClick(params.row.dev_eui)}
          size="small"
        >
          <InfoIcon fontSize="small" />
        </IconButton>
      )
    }
  ];

  const onFilterChange = (obj) => {
    console.log('obj', obj);
    if (obj.quickFilterValues && obj.quickFilterValues.length > 0) {
      setQuery(obj.quickFilterValues[0])
      if (obj.quickFilterValues[0].length > 2) {
        setQuery(obj.quickFilterValues[0])
        setPage(0)
        setRefresh(!refresh)
      }
    } else {
      setQuery('')
      setPage(0)
      setRefresh(!refresh)
    }
  }

  function QuickSearchToolbar() {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter onKeyDown={handleKeyPress}  debounceMs={3000}  sx={{ width: '100%' }} />
      </Box>
    );
  }

  const BatchFilter = () => {
    return (
      <FormControl sx={{ 
        m: 1, 
        minWidth: 200,
        maxWidth: { xs: '100%', md: 300 }
      }}>
        <InputLabel id="batch-filter-label">Filter by Batch</InputLabel>
        <Select
          labelId="batch-filter-label"
          id="batch-filter"
          value={selectedBatches}
          onChange={(event) => {
            setSelectedBatches(event.target.value);
            setPage(0);
            setRefresh(!refresh);
          }}
          input={<OutlinedInput label="Filter by Batch" />}
          sx={{
            '& .MuiSelect-select': {
              textAlign: 'left'
            }
          }}
        >
          <MenuItem value="all">All Devices</MenuItem>
          {availableBatches.map((batch) => (
            <MenuItem key={batch.batch_id} value={batch.batch_id}>
              {batch.batch_name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const MatchStatusFilter = () => {
    return (
      <FormControl sx={{ 
        m: 1, 
        minWidth: 200,
        maxWidth: { xs: '100%', md: 300 }
      }}>
        <InputLabel id="match-status-filter-label">Filter by Status</InputLabel>
        <Select
          labelId="match-status-filter-label"
          id="match-status-filter"
          value={matchStatus}
          onChange={(event) => {
            setMatchStatus(event.target.value);
            setPage(0);
            setRefresh(!refresh);
          }}
          input={<OutlinedInput label="Filter by Status" />}
          sx={{
            '& .MuiSelect-select': {
              textAlign: 'left'
            }
          }}
        >
          <MenuItem value="all">All Devices</MenuItem>
          <MenuItem value="matched">Matched Only</MenuItem>
          <MenuItem value="unmatched">Unmatched Only</MenuItem>
        </Select>
      </FormControl>
    );
  };

  const QcStatusFilter = () => {
    return (
      <FormControl sx={{ 
        m: 1, 
        minWidth: 200,
        maxWidth: { xs: '100%', md: 300 }
      }}>
        <InputLabel id="qc-status-filter-label">Filter by QC Status</InputLabel>
        <Select
          labelId="qc-status-filter-label"
          id="qc-status-filter"
          value={qcStatus}
          onChange={(event) => {
            setQcStatus(event.target.value);
            setPage(0);
            setRefresh(!refresh);
          }}
          input={<OutlinedInput label="Filter by QC Status" />}
          sx={{
            '& .MuiSelect-select': {
              textAlign: 'left'
            }
          }}
        >
          <MenuItem value="all">All Devices</MenuItem>
          <MenuItem value="approved">QC Approved</MenuItem>
          <MenuItem value="rejected">QC Rejected</MenuItem>
          <MenuItem value="pending">QC Pending</MenuItem>
        </Select>
      </FormControl>
    );
  };

  const QrMatchFilter = () => {
    return (
      <FormControl sx={{ 
        m: 1, 
        minWidth: 200,
        maxWidth: { xs: '100%', md: 300 }
      }}>
        <InputLabel id="qr-match-filter-label">Filter by QR Match</InputLabel>
        <Select
          labelId="qr-match-filter-label"
          id="qr-match-filter"
          value={qrMatchStatus}
          onChange={(event) => {
            setQrMatchStatus(event.target.value);
            setPage(0);
            setRefresh(!refresh);
          }}
          input={<OutlinedInput label="Filter by QR Match" />}
          sx={{
            '& .MuiSelect-select': {
              textAlign: 'left'
            }
          }}
        >
          <MenuItem value="all">All Devices</MenuItem>
          <MenuItem value="matched">QR Matched</MenuItem>
          <MenuItem value="unmatched">QR Unmatched</MenuItem>
        </Select>
      </FormControl>
    );
  };

  const DeviceModelFilter = () => {
    return (
      <FormControl sx={{ 
        m: 1, 
        minWidth: 200,
        maxWidth: { xs: '100%', md: 300 }
      }}>
        <InputLabel id="device-model-filter-label">Filter by Device Model</InputLabel>
        <Select
          labelId="device-model-filter-label"
          id="device-model-filter"
          value={deviceModel}
          onChange={(event) => {
            setDeviceModel(event.target.value);
            setPage(0);
            setRefresh(!refresh);
          }}
          input={<OutlinedInput label="Filter by Device Model" />}
          sx={{
            '& .MuiSelect-select': {
              textAlign: 'left'
            }
          }}
        >
          <MenuItem value="all">All Models</MenuItem>
          <MenuItem value="MODEM-E">MODEM-E</MenuItem>
          <MenuItem value="LBM">LBM</MenuItem>
        </Select>
      </FormControl>
    );
  };

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.target;
    
    if (!isLoading && hasMore && (scrollHeight - scrollTop <= clientHeight + 100)) {
      setPage(prev => prev + 1);
      loadServerRows(true);
    }
  };

  const handleInfoClick = (devEui) => {
    setSelectedDevEui(devEui);
    setDetailsOpen(true);
  };

  const handleQcUpdate = () => {
    setPage(0);
    setRefresh(!refresh);
  };

  const isAnyFilterActive = () => {
    return selectedBatches !== 'all' || 
           matchStatus !== 'all' || 
           qcStatus !== 'all' || 
           qrMatchStatus !== 'all' ||
           deviceModel !== 'all';
  };

  const handleKeyPress = (event) => {
    console.log('query', event.target.value);
    if (event.key === 'Enter') {
      setQuery(event.target.value);
      setPage(0);
      setRefresh(!refresh);
    }
  };


  const exportToExcel = async () => {
    try {
      const batchQuery = selectedBatches === 'all' ? '' : 
        selectedBatches ? `&batchIds=${selectedBatches}` : '';
      const matchStatusQuery = matchStatus !== 'all' ? `&matchStatus=${matchStatus}` : '';
      const qcStatusQuery = qcStatus !== 'all' ? `&qcStatus=${qcStatus}` : '';
      const qrMatchQuery = qrMatchStatus !== 'all' ? `&qrMatchStatus=${qrMatchStatus}` : '';
      const deviceModelQuery = deviceModel !== 'all' ? `&deviceModel=${deviceModel}` : '';
      const queryParam = query ? `&query=${query}` : '';

      const response = await api.get(
        `/export_matched_devices?${batchQuery}${matchStatusQuery}${qcStatusQuery}${qrMatchQuery}${deviceModelQuery}${queryParam}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + localStorage.getItem("jwt"),
          },
          responseType: 'blob'
        }
      );

      // Create a URL for the blob
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'matched_devices.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      window.showToast('Error exporting to Excel: ' + error.message, 'error');
    }
  }

  return (
    <div className="App">
      <Logo />
      <LogoutButton />
      <header className="App-header">
        {token.length > 0 ? (
          <div style={{paddingTop:'10px'}}>
            <Button variant="contained" onClick={() => navigate("/matchcodes")}>
              Match New QR Codes
            </Button>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              gap: 1
            }}>
              <p style={{ color: 'black', margin: 0, padding: 10 }}>
                Matched List ({totalRows})
                {isAnyFilterActive() && (
                  <span style={{ color: '#ef5350',fontWeight:'bold' }}> - filtered</span>
                )}
              </p>
              <IconButton 
                onClick={() => setFilterDialogOpen(true)}
                size="small"
                sx={{ 
                  color: isAnyFilterActive() ? '#ef5350' : '#1976d2',
                  bgcolor: isAnyFilterActive() 
                    ? 'rgba(239, 83, 80, 0.08)'
                    : 'rgba(25, 118, 210, 0.08)',
                  '&:hover': {
                    bgcolor: isAnyFilterActive()
                      ? 'rgba(239, 83, 80, 0.12)'
                      : 'rgba(25, 118, 210, 0.12)',
                  }
                }}
              >
                <FilterIcon />
              </IconButton>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                onClick={() => {
                  exportToExcel();
                }}
                size="small"
                sx={{ 
                  backgroundColor: '#1976d2',
                  '&:hover': {
                    backgroundColor: '#1565c0',
                  }
                }}
              >
                Export
              </Button>
            </Box>

            <FilterDialog
              open={filterDialogOpen}
              onClose={() => setFilterDialogOpen(false)}
              BatchFilter={BatchFilter}
              MatchStatusFilter={MatchStatusFilter}
              QcStatusFilter={QcStatusFilter}
              QrMatchFilter={QrMatchFilter}
              DeviceModelFilter={DeviceModelFilter}
            />

            <div style={{
              width: '100%',
              maxWidth: '100vw',
              padding: '0 4px',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden'
            }}>
              {!isLandscape && (
                <div style={{
                  padding: '8px',
                  textAlign: 'center',
                  color: '#666',
                  fontSize: '0.8rem',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '4px',
                  margin: '8px 0'
                }}>
                  Rotate screen horizontally for more detailed information
                </div>
              )}

              <div style={{
                width: '100%',
                display: 'flex',
                overflow: 'hidden',
                paddingLeft: '10px',
                paddingRight: '10px'
              }}>
                <div 
                  style={{
                    height: '60vh',
                    width: '100%',
                    overflow: 'auto'
                  }}
                  onScroll={handleScroll}
                >
                  <DataGrid
                    rows={rows}
                    columns={isLandscape ? landscapeColumns : portraitColumns}
                    hideFooterPagination
                    hideFooter
                    autoHeight
                    disableColumnMenu
                    disableColumnFilter
                    disableColumnSelector
                    disableDensitySelector
                    components={{
                      Toolbar: QuickSearchToolbar,
                    }}
                    componentsProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    onFilterModelChange={onFilterChange}
                    loading={isLoading}
                    sx={{
                      '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid #e0e0e0',
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: '#1976d2',
                        color: 'white',
                        minHeight: '40px !important',
                        maxHeight: '40px !important',
                        lineHeight: '40px !important',
                      },
                      '& .MuiDataGrid-columnHeaderTitleContainer': {
                        padding: '0 8px',
                      },
                      '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: '#f5f5f5',
                      },
                      '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#e3f2fd',
                      }
                    }}
                  />
                  {isLoading && (
                    <div style={{
                      textAlign: 'center',
                      padding: '10px',
                      color: '#666'
                    }}>
                      Loading more...
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <p style={{color:'black'}}>
              MFG QR Match - Login
            </p>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField id="outlined-basic" value={email} onChange={(val)=>setEmail(val.target.value)} label="Email Address" variant="outlined" />
              </Grid>
              <Grid item xs={12}>
                <TextField id="outlined-basic" value={password} onChange={(val)=>setPassword(val.target.value)} label="Password" type="password" variant="outlined" />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" onClick={()=>onLogin()}>Login</Button>      
              </Grid>
            </Grid>
          </div>
        )}
      </header>
      <DeviceInfoDialog 
        open={detailsOpen}
        onClose={() => {
          setDetailsOpen(false);
          setSelectedDevEui(null);
          setPage(0);
          setRefresh(!refresh);
        }}
        devEui={selectedDevEui}
        onQcUpdate={handleQcUpdate}
      />
    </div>
  )
}

export default MatchedList;